import React, { useEffect, useState } from 'react'
import { fetchOrderHistory, getOrderActions } from 'services'
import { Loader } from 'components/Shared/Loader'
import OrderDetailsHeader from 'components/Order/OrderDetails/OrderDetailsHeader'
import { useErrorHandling } from 'context/errorHandling'
import { Autocomplete } from '@material-ui/lab'
import TextField from '@material-ui/core/TextField'
import { ReactComponent as DropdownIcon } from 'assets/icons/dropdown.svg'
import { useTranslation } from 'react-i18next'
import styles from './EditHistory.module.css'
import { toDisplayDateTime } from 'utils/date'
import { OrderData } from 'components/Order/OrderDetails/OrderData'

export function OrderEditHistory (props) {
  const [editActions, setEditActions] = useState(null)
  const id = props.match.params.id
  const editId = props.match.params.editId
  const { handleError } = useErrorHandling()
  const [currentSelectedAction, setCurrentSelectedAction] = useState(null)
  const { t } = useTranslation()
  const [orderHistory, setOrderHistory] = useState(null)

  const [orderBeforeEdit, setOrderBeforeEdit] = useState(null)
  const [orderAfterEdit, setOrderAfterEdit] = useState(null)

  useEffect(() => {
    if (currentSelectedAction && orderHistory) {
      let index = orderHistory.findIndex(value => value.version === currentSelectedAction.versionBeforeEdit)
      setOrderBeforeEdit(orderHistory[index])
      setOrderAfterEdit(orderHistory[index + 1])
    }
  }, [currentSelectedAction, orderHistory])

  useEffect(() => {
    fetchOrderHistory(id).then(setOrderHistory).catch(handleError)
  }, [id, handleError])

  useEffect(() => {
    getOrderActions(id)
      .then(response => {
        let editActions = response.filter(action => action.actionType === 'EDIT' && action.versionBeforeEdit)
        setCurrentSelectedAction(editActions.find(action => action.id === editId))
        setEditActions(editActions)
      })
      .catch(handleError)
  }, [id, editId, handleError])

  return (orderAfterEdit) ? <div>
      <OrderDetailsHeader order={orderAfterEdit}>
        <Autocomplete
          options={editActions}
          id={'versionSelect'}
          disableClearable
          filterSelectedOptions
          getOptionLabel={option => `${toDisplayDateTime(option.creationDateTime)} ${option.actionExecutor.firstName} ${option.actionExecutor.lastName}`
          }
          value={currentSelectedAction}
          onChange={(e, newValue) => setCurrentSelectedAction(newValue)}
          renderInput={params => (
            <TextField
              {...params}
              label={t('order.details.history.editHistory.selectEditAction')}
              variant="filled"
              fullWidth
              InputProps={{ ...params.InputProps, disableUnderline: true }}
              className={styles.selectEdit}
            />
          )}
          popupIcon={<DropdownIcon/>}
        />
      </OrderDetailsHeader>
      <OrderData order={orderAfterEdit} previousOrder={orderBeforeEdit} expandPointsList/>
    </div> :
    <Loader/>
}
